import request from '@/api/request.js'

// 新增
export function QuestionOptionInsert(data) {
    return request({
        url: '/api/question/questionoptioninsert',
        method: 'post',
        data: data
    })
}

// 新增
export function QuestionOptionInsertMany(data) {
    return request({
        url: '/api/question/questionoptioninsertmany',
        method: 'post',
        data: data
    })
}

// 删除
export function QuestionOptionDelete(id) {
    return request({
        url: `/api/question/questionoptiondelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function QuestionOptionUpdate(id, data) {
    return request({
        url: `/api/question/questionoptionupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function QuestionOptionGetById(id) {
    return request({
        url: `/api/question/getquestionoptionbyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function QuestionOptionGetList(params) {
    return request({
        url: '/api/question/getquestionoptionlist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function QuestionOptionGetPageList(params) {
    return request({
        url: '/api/question/getquestionoptionpagelist',
        method: 'get',
        params: params
    })
}